export interface ITournament {
  id: number;
  tournament_type: string;
  date: string;
  start_time: string;
  end_time: string;
  level_from: number;
  level_to: number | null;
  entry_fee: number;
  max_players: number | null;
  organizer_name: string;
  organizer_phone: string;
  description?: string | null;
  is_enjoying?: boolean;
  is_created?: boolean;
  applications?: ITournamentApplication[];
}

export interface ITournamentApplication {
  id: number;
  name: string;
  contactPhone: string;
  level: number;
  type: "single" | "pair";
  partnerName?: string;
  partnerPhone?: string;
  is_seen: boolean;
  status: "pending" | "approved" | "rejected";
  is_paid: boolean;
  created_at?: string;
}

export interface ITournamentsState {
  tournamentsLoading: boolean;
  availableTournaments: ITournament[];
  myApplicationsTournaments: ITournament[];
  myCreatedTournaments: ITournament[];
  userTournamentStatus: string | null;
  applicationsCount: number;
  tournamentTypes: string[];
}

export interface ICreateTournamentData {
  tournamentType: string;
  date: string;
  startTime: string;
  endTime: string;
  levelFrom: number;
  levelTo: number | null;
  entryFee: number;
  maxPlayers: number | null;
  organizerName: string;
  organizerPhone: string;
  description?: string;
}

export interface IApplyTournamentData {
  level: number;
  name: string;
  contactPhone: string;
}

export const TOURNAMENT_USER_TYPES = {
  PARTICIPANT: "USER",
  ORGANIZER: "ORGANIZATOR",
} as const;
